import { useState } from 'react';
import { object, string } from 'yup';

import { deleteUsersApi, editUsersApi, getUsersApi, getUsersByNameApi, registerUsersApi } from '../services/usersAPI';

export const useUsers = () => {
  const [loading, setLoading] = useState(false);

    const checkPayload = async (user) => {
      const schema = object().shape({
        name: string().required().min(7),
        email: string().required().email(),
        role: string().required().min(3),
        password: string().required()
          .min(8, 'Deve conter no minimo 8 caracteres.')
          .matches(/[a-z]/, 'deve conter ao menos uma letra minúscula')
          .matches(/[A-Z]/, 'Deve conter ao menos uma letra maiúscula')
          .matches(/[0-9]/, 'Deve conter ao menos um número')
      });
    
      try {
        return await schema.validate(user);
      } catch (error) {
        return { errorMessage: `'${error.path}' ${error.message}` };
      }
    }
  
  const getUsers = async (name, page, size) => {
    setLoading(true);
    let result = [];

    if(name) {
      result = await getUsersByNameApi(name.trim());
    } else {
      result = await getUsersApi(page, size);
    }

    setLoading(false);
    return result;
  };

  const deleteUsers = async (id) => {
    setLoading(true);
    const result = await deleteUsersApi(id);
    setLoading(false);
    return result;
  };

  const editUsers = async (user) => {
    const isValidated = await checkPayload(user);
    if (isValidated.errorMessage) {
      return isValidated;
    }

    setLoading(true);
    const result = await editUsersApi(user);
    setLoading(false);
    return result;
  };

  const registerUsers = async (user) => {
    const isValidated = await checkPayload(user);
    if (isValidated.errorMessage) {
      return isValidated;
    }

    setLoading(true);
    const result = await registerUsersApi(user);
    setLoading(false);
    return result;
  };
  
  return {
    loading,
    getUsers,
    deleteUsers,
    editUsers,
    registerUsers,
  };
};
